'use client'

import { ComponentProps } from 'react'
import { CheckmarkShield12 } from '@vinted/monochrome-icons'
import { Cell, Icon, Navigation, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = Pick<ComponentProps<typeof Navigation>, 'left'>

const ConversationHeader = (props: Props) => {
  const translate = useTranslate()

  return (
    <div className="conversation-header">
      <Navigation
        {...props}
        body={
          <Cell styling="tight">
            <Text
              as="h2"
              type="title"
              text={
                <>
                  {translate('conversations.list.braze.message_title')}
                  <Spacer orientation="vertical" size="small" />
                  <Icon
                    name={CheckmarkShield12}
                    color="primary-default"
                    aria={{ 'aria-label': translate('inbox.a11y.moderator_badge') }}
                    testId="moderator-badge-icon"
                  />
                </>
              }
              theme="amplified"
            />
          </Cell>
        }
      />
    </div>
  )
}

export default ConversationHeader
